<template>


	<div class="product-outline">
		<div class="row px-3">
			<span class="page-heading-crumbs my-auto col">{{title}}</span>
			<el-dropdown class="my-auto mr-2" trigger="click" @command="handleCommand" @visible-change="onMenuOpened">
				<span class="my-auto el-dropdown-link" style="cursor: pointer;">
					...
				</span>
				<template #dropdown><el-dropdown-menu>
					<el-dropdown-item command="collapseAll">Collapse All</el-dropdown-item>
					<el-dropdown-item command="expandAll">Expand All</el-dropdown-item>
				</el-dropdown-menu></template>
			</el-dropdown>
		</div>


		<el-collapse v-model="expandedData" @change="handleCollapseStateChange">
			<!--<vs-collapse>-->
			<Container
				orientation="vertical"
				@drop="onColumnDrop($event)"
				drag-handle-selector=".column-drag-handle"
				@drag-start="dragStart"
				:get-child-payload="getSectionPayload"
				:should-accept-drop="shouldAcceptSectionDrop"
			>
				<Draggable v-for="(section, index) in data.programSteps" :key="section.id"

				>
					<div :class="['category']" v-if="isExpandable(section, index)">
						<el-collapse-item :name="index" :disabled="!isExpandable(section, index)">
							<template #title>
								<div class="section-title" :class="{clickable: canEditSection(section)}" >
									<SectionRow
										:programStep="section"
										:isInClientMode="isInClientMode"
										:isInCoachMode="isInCoachMode"
										:isEditable="canEditSection(section)"
										:isDraggable="canDragSection(section)"
										@onTitleClicked="notifySectionClicked(section)"
										@onDeleteClicked="notifySectionDeleteClicked(section)"
										:class="{clickable: isExpandable(section)}"
									>
										<small>
										<span v-if="isSectionLockedByPayment(section)">
											Complete payment to unlock
										</span>

											<span v-else-if="section.hasPaymentLocker()">

											<strong>
												<span v-if="section.isLockedByPayment()">
													<span class="dot badge-warning"></span>
													Payment Due:
												</span>
												<span v-else>
													<span class="dot badge-success"></span>
													Paid:
												</span>
												<span>
												{{currencyFormatted(section.lockerState.paymentAmount)}}
																<ToolTipView :analyticsProps="{label: 'Payment milestone', ...analyticsPropsMethod()}"
																			 v-if="isInCoachMode"
																			 :text="'Payment Due: your client would be required to pay the specified amount before they can access this and the subsequent sections of this caching process.'">
																</ToolTipView>

												</span>
											</strong>
										</span>
										</small>

									</SectionRow>
								</div>
							</template>

							<div v-if="isLockedBySubscription(index) && !isCoach">
								<SubscribeLockerView
									:coachingProgram="data"
									:analytics-props="analyticsPropsMethod()"
									@paymentSuccess="onPaymentSuccess"/>
							</div>
							<div v-else-if="section.isLocked() && !isCoach">

								<CompletePaymentLockerView
									v-if="section.isLockedByPayment()"
									:lockerState="section.lockerState"
									:analytics-props="analyticsPropsMethod()"
									@paymentSuccess="onPaymentSuccess">

								</CompletePaymentLockerView>
							</div>
							<Container
								v-else
								class="category-contents-wrapper category-contents"
								group-name="col"
								@drop="(e) => onCardDrop(section.id, e)"
								@drag-start="(e) => log('drag start', e)"
								@drag-end="(e) => log('drag end', e)"
								:get-child-payload="getCardPayload(section.id)"
								:should-accept-drop="shouldAcceptItemDrop"
								drag-handle-selector=".column-drag-handle"
								drag-class="card-ghost-class"
								drop-class="card-ghost-class"
							>
								<Draggable v-for="(programStep, itemIndex) in filteredStepList(section.subStepList)"
										   :key="programStep.id">
									<div @click="notifyItemClicked(programStep, index)">
										<component
											:is="rowComponentName(programStep)"
											:program="data"
											:programStep="programStep"
											:sectionIndex="index"
											:itemIndex="itemIndex"
											:isInClientMode="isInClientMode"
											:isInCoachMode="isInCoachMode"
											:isEditable="canEditSection(section)"
											:clientsCount="clientsCount"
											:analyticsProps="analyticsProps"
											@onItemCompletionToggleRow="notifyItemToggleCompletion"
										/>
									</div>

								</Draggable>
								<div v-if="canShowActionButtons()" class="col p-0">

									<li v-if="canShowNewContractButton(index)"
										@click="onAddContractClicked(index)" class="post col p-1"
										style="border-bottom: none; text-align: center; padding: 5px; cursor: pointer;">
										<small><i class="fontello icon-handshake-o icon-primary pr-2"></i>Add agreement</small>
									</li>
									<li v-if="canShowNewCallButton(section, index)"
										@click="onAddCallClicked(index)" class="post col p-1"
										style="border-bottom: none; text-align: center; padding: 5px; cursor: pointer;">
										<small>
											<i class="fontello icon-chat icon-primary"></i>
											Schedule coaching session
										</small>

									</li>
									<li v-if="canShowNewTaskButton()"
										@click="onAddTaskClicked(index)" class="post col p-1"
										style="border-bottom: none; text-align: center; padding: 5px; cursor: pointer;">
										<small><i class="fontello icon-calendar-check-o icon-primary"></i>Add action item</small>
									</li>
									<li v-if="canShowNewNoteButton()"
										@click="onAddNoteClicked(index)" class="post col p-1"
										style="border-bottom: none; text-align: center; padding: 5px; cursor: pointer;">
										<small><i class="fontello icon-edit icon-primary"></i>Add new note</small>
									</li>
								</div>
							</Container>
						</el-collapse-item>
						<!--</vs-collapse-item>-->
					</div>
				</Draggable>
			</Container>
		</el-collapse>
		<!--</vs-collapse>-->
		<div v-if="hasNotCompletedRecurringSession()" class="new-recurring-sessions-note">
			<small class="text-muted">
				<ToolTipView :analyticsProps="tooltipAnalyticsProps" >
					<template #icon><i  class="fontello icon-arrows-cw pr-2" style="color: rgb(118, 119, 121)"/></template>
					This program contains recurring session.
					<br/><br/>
					New sessions will appear automatically as current sessions are completed.
				</ToolTipView>
				<span v-if="hasActiveRecurringSession">Recurring sessions: future sessions will appear here as current sessions are completed.</span>
				<span v-else>Recurring sessions: no more future sessions.</span>
			</small>
		</div>

		<el-button v-if="!hasActiveRecurringSession && canShowNewCallExtraButton"
				   @click="onAddSectionWithCallClicked"
				   plain
				   class="w-100 mt-4">
			<i class="fontello icon-chat icon-primary"></i>
			Schedule coaching session
		</el-button>


		<el-button v-else-if="!hasActiveRecurringSession && canShowNewSectionButton()"
				   @click="onAddSectionClicked"
				   plain type="primary"
				   class="w-100 mt-4">
			Add new section
		</el-button>



	</div>
</template>

<script>
	import CoachingProgram from '@/core/js/model/Program/CoachingProgram'
	import {Container, Draggable} from 'vue3-smooth-dnd'
	import {applyDrag} from '@/utils/helpers'
	import {StepType} from "@shared/Program/ProgramStep/helpers/ProgramStepEnums";
	import {plainToClass} from "class-transformer";
	import TaskRow from "./row/TaskRow"
	import CallRow from "./row/CallRow"
	import SectionRow from "./row/SectionRow"
	import NoteRow from "./row/NoteRow"
	import ContractRow from "./row/ContractRow"
	import {debounce} from 'vue-debounce'
	import CompletePaymentLockerView from "@/core/components/ProgramAgenda/CompletePaymentLockerView.vue";
	import ToolTipView from "@/core/components/Form/Base/ToolTipView.vue";
	import {classToClass} from "@qwoach/class-transformer-wrapper";

	import BaseComponent from "@/core/components/BaseComponent.vue";
	import SectionProgramStep from "@shared/Program/ProgramStep/SectionProgramStep";
	import SubscribeLockerView from "@/core/components/ProgramAgenda/SubscribeLockerView.vue";

	export default {
		extends: BaseComponent,
		name: 'ProgramAgenda',
		props: {
		    title: {type: String, default: 'Program outline'},
			data: {type: CoachingProgram, default: () => new CoachingProgram()},
			clientsCount: {type: Number, default: 0},
			isInCoachMode: {type: Boolean, default: true},
			isInClientMode: {type: Boolean, default: false},
			hideAddCoachingSession: {type: Boolean, default: false},
			tooltipAnalyticsProps: Object,
			analyticsProps: Object
		},
		components: {
			SubscribeLockerView,
			ToolTipView,
			CompletePaymentLockerView,
			Container,
			Draggable,
			TaskRow,
			CallRow,
			NoteRow,
			SectionRow,
			ContractRow
		},
		data() {
			return {
				expandedData:[],
				mouseHoverItemIndex: -1
			}
		},
		watch: {
			data:{
				immediate: true,
				handler(){
					if(this.data){
						this.ensureSectionsType()
						this.syncExpandedItemsFromProgram()
					}
				}
			}
		},
		created(){
			// this.syncExpandedItemsFromProgram()
		},
		mounted() {
			console.log("programagenda mounted")
			this.notifyDataChanged = debounce(this.notifyDataChanged, 100)
			// this.expandAll();
		},
		methods: {

			async onPaymentSuccess(){
				return await this.emitPromise("paymentSuccess")
			},

			hasNotCompletedRecurringSession(){
				let res = this.data.hasNotCompletedRecurringSession()
				console.log("hasNotCompletedRecurringSession: res = ", res)
				return res
			},
			hasRecurringSession(){
				let res = this.data.findAllRecurringSessionSteps().length > 0
				console.log("hasRecurringSession: res = ", res)
				return res
			},

			canEditSection(section){
				return this.isCoach || (this.data.clientAccessSettings.canEdit && !section.isLocked() && !this.isSectionLockedByPayment(section))
			},
			canDragSection(section){
				let hasRecurringSessions = this.data.findAllRecurringSessionSteps([section]).length > 0
				// console.log("canDragSection: hasRecurringSessions = ", hasRecurringSessions, ", section = ", section)
				return this.canEditSection(section) && !hasRecurringSessions
			},
			filteredStepList(steps){
				console.log("filteredStepList")
				return steps.filter(step => {
					let canShow = step.canShowTo(this.userProfile.id)
					// console.log("step = ", step)
					if(step.isTypeContract() && !step.contract && !this.isCoach){
						canShow = false
					}

					return canShow
				})
			},
			canShowNewSectionButton(){
				let canCreateSections = this.data.clientAccessSettings.canCreateSections
				return canCreateSections || this.isCoach
			},
			canShowNewCallButton(section, index){
				let sessions = section.findSubStepsByType(StepType.CALL)
				let hasCoachingSession = sessions.length > 0
				let canSchedule = this.canScheduleMoreSessions//this.data.clientAccessSettings.canCreateSessionDetails
				return index > 0 && !hasCoachingSession && !this.hideAddCoachingSession && (canSchedule || this.isCoach)
			},

			canShowNewTaskButton(){
				let canCreateActionItems = this.data.clientAccessSettings.canCreateActionItems
				return canCreateActionItems || this.isCoach
			},
			canShowNewNoteButton(){
				let canCreateNotes = this.data.clientAccessSettings.canCreateNotes
				return canCreateNotes || this.isCoach
			},
			canShowNewContractButton(index){
				let contractCount = this.data.findStepAll(step => step.isTypeContract()).length
				return this.isCoach && index === 0 && contractCount === 0
			},
			canShowActionButtons(){
				return true
			},
			rowComponentName(programStep) {
				switch (programStep.stepType) {
					case StepType.CALL:
						return "CallRow";
					case StepType.TASK:
						return "TaskRow";
					case StepType.NOTE:
						return "NoteRow";
					case StepType.CONTRACT:
						return "ContractRow";
				}
			},
			isItemChecked(task, index, itemIndex) {
				let pathNumber = this.indexPathToNumber(index, itemIndex);
				let res = this.mouseHoverItemIndex == pathNumber || task.isCompletedBy(this.currentUser.uid)
				return res;
			},
			isItemCompleted(task) {
				return task.isCompletedBy(this.currentUser.uid);
			},
			isItemCompletedCoach(task) {
				return task.isCompleted();
			},
			indexPathToNumber(index, itemIndex) {
				return index * 100000 + itemIndex;
			},
			programAnalyticData(){
				return {
					program_name: this.data.name,
					program_id: this.data.id
				}
			},
			notifySectionClicked(item){
				if(this.canEditSection(item)){
					this.$analyticManager.trackEvent("Section clicked", {item_name: item.name, item_id: item.id, ...this.analyticsPropsMethod()})
					this.$emit("onSectionClicked", item)
				}
			},
			notifySectionDeleteClicked(item){
				if(this.canEditSection(item)){
					this.$emit("onSectionDeleteClicked", item)
				}
			},
			notifyItemToggleCompletion(item) {
				console.log("notifyItemToggleCompletion: item = ", item)
				this.$emit("onItemCompletionToggle", item)
			},
			notifyItemClicked(item, sectionIndex) {
				this.$analyticManager.trackEvent("Open program item clicked", {label: item.name, item_type: item.stepType, section_index: sectionIndex, ...this.programAnalyticData()})
				this.$emit("onItemClicked", item)
			},
			notifyAddTaskClicked(sectionIndex) {
				this.$analyticManager.trackEvent("Add program item clicked", {category: "action item", section_index: sectionIndex, ...this.programAnalyticData()})
				this.$emit("addTaskClicked", sectionIndex)
			},
			notifyAddNoteClicked(sectionIndex) {
				this.$analyticManager.trackEvent("Add program item clicked", {category: "note", section_index: sectionIndex, ...this.programAnalyticData()})
				this.$emit("addNoteClicked", sectionIndex)
			},
			notifyAddCallClicked(sectionIndex) {
				this.$analyticManager.trackEvent("Add program item clicked", {category: "coaching session", section_index: sectionIndex, ...this.programAnalyticData()})
				this.$emit("addCallClicked", sectionIndex)
			},
			notifyDataChanged() {
				this.$emit("change", this.data)
			},
			notifyDataChangedSilent() {
				this.$emit("changeSilent", this.data)
			},

			notifyError(error) {
				this.$emit("error", error)
			},
			onAddTaskClicked(sectionIndex) {
				this.notifyAddTaskClicked(sectionIndex)
			},
			onAddNoteClicked(sectionIndex) {
				this.notifyAddNoteClicked(sectionIndex)
			},
			onAddContractClicked(sectionIndex){
				this.$analyticManager.trackEvent("Add program item clicked", {category: "agreement", section_index: sectionIndex, ...this.programAnalyticData()})
				this.$emit("onAddContractClicked", sectionIndex)
			},

			onAddCallClicked(sectionIndex) {
				this.notifyAddCallClicked(sectionIndex)
			},
			onAddSectionClicked() {
				this.$analyticManager.trackEvent("Add program item clicked", {category: "section", ...this.programAnalyticData()})
				this.$emit("addSectionClicked")
			},
			onAddSectionWithCallClicked(){
				this.$emit("addSectionWithSessionClicked")
			},

			onMenuOpened(isOpened){
				if(isOpened){
					this.$analyticManager.trackEvent("Program menu clicked", this.programAnalyticData())
				}
			},

			handleCommand(command) {
				switch (command) {
					case 'collapseAll':
						this.$analyticManager.trackEvent("Program menu item clicked", {label: "collapseAll", ...this.programAnalyticData()})
						this.collapseAll();
						break;
					case 'expandAll':
						this.$analyticManager.trackEvent("Program menu item clicked", {label: "expandAll", ...this.programAnalyticData()})
						this.expandAll();
						break;
				}
			},

			isLockedBySubscription(sectionIndex){
				let billingItem = this.data.recurringBillingItem
				if(sectionIndex > 0 && billingItem.isEnabled && !billingItem.isActive()){
					return true
				}
				return false
			},

			shouldAcceptSectionDrop(src, payload){
				console.log("shouldAcceptSectionDrop: src = ", src, ", payload = ", payload)
				return payload instanceof SectionProgramStep
			},
			shouldAcceptItemDrop(src, payload){
				console.log("shouldAcceptItemDrop: src = ", src, ", payload = ", payload)
				return !(payload instanceof SectionProgramStep)
			},
			onColumnDrop(dropResult) {
				console.log("onColumnDrop: dropResult = ", dropResult)
				if(!dropResult.removedIndex && !dropResult.addedIndex){
					return
				}
				let section = this.data.programSteps[dropResult.removedIndex] || {}
				this.$analyticManager.trackEvent("Drag-n-drop", {target: "section", title: section.name, from_position: dropResult.removedIndex, to_position: dropResult.addedIndex, ...this.analyticsPropsMethod()})
				const scene = classToClass(this.data)
				scene.programSteps = applyDrag(scene.programSteps, dropResult)
				// eslint-disable-next-line vue/no-mutating-props
				this.data = plainToClass(CoachingProgram, scene)
				this.syncExpandedStateOnDrop(dropResult)
				this.notifyDataChanged()
			},
			syncExpandedStateOnDrop(dropResult) {
				var src = dropResult.removedIndex;
				var dst = dropResult.addedIndex;
				var dragLeft = Math.min(src, dst)
				var dragRight = Math.max(src, dst)
				var diff = Math.sign(src - dst);
				var isDraggingItemExpanded = false;

				var expandedItemsCopy = this.expandedItems.slice();
				// console.log('src = ', src, ', dst = ', dst, ', diff = ', diff, ', dragLeft = ', dragLeft, ', dragRight = ', dragRight)
				// console.log('before: expandedItemsCopy = ', expandedItemsCopy)
				// console.log('before: this.expandedItems = ', this.expandedItems)

				for (var i = 0; i < expandedItemsCopy.length; i++) {
					var item = expandedItemsCopy[i];
					if (item === src) {
						isDraggingItemExpanded = true;
						expandedItemsCopy.splice(i, 1)
						i = i - 1;
					} else if (dragLeft <= item && item <= dragRight) {
						expandedItemsCopy[i] += diff
					}
				}
				if (isDraggingItemExpanded) {
					expandedItemsCopy.push(dst)
				}
				this.expandedItems = expandedItemsCopy;
				// console.log('isDraggingItemExpanded = ', isDraggingItemExpanded)
				// console.log('expandedItemsCopy = ', expandedItemsCopy)
				// console.log('this.expandedItems = ', this.expandedItems)
			},
			onCardDrop(columnId, dropResult) {
				console.log('dropResult = ', dropResult)
				if (dropResult.removedIndex !== null || dropResult.addedIndex !== null) {
					const scene = classToClass(this.data)
					const column = scene.programSteps.filter(p => p.id === columnId)[0]
					const columnIndex = scene.programSteps.indexOf(column)
					const newColumn = classToClass(column)
					let item = newColumn.subStepList[dropResult.removedIndex] || {}
					this.$analyticManager.trackEvent("Drag-n-drop", {target: "program item", title: item.name, from_position: dropResult.removedIndex, to_position: dropResult.addedIndex, ...this.analyticsPropsMethod()})
					newColumn.subStepList = applyDrag(newColumn.subStepList, dropResult)
					scene.programSteps.splice(columnIndex, 1, newColumn)
					// eslint-disable-next-line vue/no-mutating-props
					this.data = plainToClass(CoachingProgram, scene)

					this.notifyDataChanged()
				}
			},
			getCardPayload(columnId) {
				return index => {
					var filtered = this.data.programSteps.filter(p => p.id === columnId)
					var filtered0 = filtered[0]
					return filtered0.subStepList[index]

				}
			},
			getSectionPayload(index) {
				return this.data.programSteps[index]
			},
			dragStart() {
				console.log('drag started')
			},
			log(...params) {
				console.log(...params)
			},
			collapseAll() {
				this.expandedItems = [];
			},
			expandAll() {
				let expandedItems = [];
				for (let i = 0; i < (this.data.programSteps || []).length; ++i) {
					expandedItems.push(i);
				}
				console.log("expandAll: this.data.programSteps = ", this.data.programSteps)
				this.expandedItems = expandedItems;
			},
			handleCollapseStateChange(expandedItems){
				this.$analyticManager.trackEvent("Sections expand state changed", {expanded_items: expandedItems, ...this.programAnalyticData()})

				console.log("handleCollapseStateChange: expandedItems = ", expandedItems)
				this.expandedItems = expandedItems
			},
			expandSection(sectionIndex) {
				this.data.programSteps[sectionIndex].expandItemForOwnerId(this.userProfile.id)
			},
			collapseSection(sectionIndex) {
				this.data.programSteps[sectionIndex].collapseItemForOwnerId(this.userProfile.id)
			},
			isExpandable(programStep, sectionIndex){
				if(this.isCoach){
					return true
				}
				if(this.isLockedBySubscription(sectionIndex - 1)){
					return false
				}
				let res = true
				for(let step of this.data.programSteps){
					// console.log("isLocked = ", step.isLocked(), ", step = ", step)
					if(step.id == programStep.id){
						break
					}
					res = res && !step.isLocked()
				}
				return res
			},
			isSectionLockedByPayment(programStep){
				if(this.isCoach){
					return false
				}
				let res = false
				for(let step of this.data.programSteps){
					// console.log("isLocked = ", step.isLockedByPayment(), ", step = ", step)
					if(step.id === programStep.id){
						break
					}
					res = res || step.isLocked()
				}
				return res
			},

			ensureSectionsType(){
				for(let i = 0; i < this.data.programSteps.length; ++i){
					let programStep = this.data.programSteps[i]
					if(!(programStep instanceof SectionProgramStep)){
						console.warn(`ProgramAgenda.ensureSectionsType: incorrect section at index ${i} removed: `, programStep)
						this.data.programSteps.splice(i, 1);
						i--
					}
				}
			},

			syncExpandedItemsFromProgram(){
				let expandedNew = []
				for(let i = 0; i < this.data.programSteps.length; ++i){
					let programStep = this.data.programSteps[i]
					if(programStep.expandedForOwnerIds.includes(this.userProfile.id) && this.isExpandable(programStep, i)){
						expandedNew.push(i)
					}
				}
				this.expandedData = expandedNew

			}
		},

		computed: {
			expandedItems:{
				get: function () {
					return this.expandedData
				},
				set: function (expanded) {
					console.log("expandedItems: set = ", expanded)
					let ownerId = this.userProfile.id
					this.data.programSteps.forEach(step => {
						console.log("expandedItems: step = ", step)
						step.collapseItemForOwnerId(ownerId)})

					expanded.forEach(expandedIndex => {
						this.data.programSteps[expandedIndex].expandItemForOwnerId(ownerId)
					})

					this.syncExpandedItemsFromProgram()

					this.notifyDataChangedSilent()
					// setTimeout(_ => this.notifyDataChangedSilent(), 500)


				}
			},

			canShowNewCallExtraButton(){
				return this.isClient && this.isAllCallSlotsUsed && this.canScheduleMoreSessions
			},

			isAllCallSlotsUsed(){
				for(let i = 0; i < this.data.programSteps.length; ++i){
					let section = this.data.programSteps[i]
					if(this.canShowNewCallButton(section, i)){
						return false
					}
				}
				return true
			},

			canScheduleMoreSessions(){
				let allSessions = this.data.findStepAll(step => step.isTypeCall())
				return allSessions.length < this.data.sessionsLimit
			},

			hasActiveRecurringSession(){
				let res = this.data.hasActiveRecurringSession()
				console.log("hasActiveRecurringSession: res = ", res)
				return res
			},

		}
	}
</script>

<style src="./ProgramAgenda.scss" lang="scss" scoped/>
<style src="./GrabbableStyle.scss" lang="scss" scoped/>


<style lang="scss">

	.new-recurring-sessions-note{
		padding: 15px;
		text-align: center;
		/*background: rgb(246, 248, 249);*/
		/*border: 1px solid #E5E9E9;*/
		/*border-radius: 5px;*/
	}

	.product-outline{
		div .el-collapse-item__content {
			padding: 0;
		}

		div .el-collapse-item__header {
			background: #f6f8f9;
			border-bottom: 1px solid #E5E9E9;
			padding: 0px 15px;
			height: auto;
			min-height: 48px;
		}

		div .el-collapse-item__header {
			border-top-left-radius: 5px;
			border-top-right-radius: 5px;
		}

		div .el-collapse-item__arrow {
			margin: 0;
		}

		/*!*div .category{*!*/

		/*!*border-bottom-right-radius: 5px;*!*/
		/*!*border-bottom-left-radius: 5px;*!*/
		/*}*/

		.section-title {
			/*height: 60px;*/
			width: 100%;
			margin-right: 0px;
			cursor: default;
			border-top-left-radius: 5px;
		}

		.el-collapse-item.is-disabled .el-collapse-item__header{
			color: #303133;

			.el-collapse-item__arrow{
				opacity: 0;
			}
		}

	}



</style>



